// const data_ENG = [
//   "Afghanistan",
//   "ÂlandIslands",
//   "Albania",
//   "Algeria",
//   "AmericanSamoa",
//   "AndorrA",
//   "Angola",
//   "Anguilla",
//   "Antarctica",
//   "AntiguaandBarbuda",
//   "Argentina",
//   "Armenia",
//   "Aruba",
//   "Australia",
//   "Austria",
//   "Azerbaijan",
//   "Bahamas",
//   "Bahrain",
//   "Bangladesh",
//   "Barbados",
//   "Belarus",
//   "Belgium",
//   "Belize",
//   "Benin",
//   "Bermuda",
//   "Bhutan",
//   "Bolivia",
//   "BosniaandHerzegovina",
//   "Botswana",
//   "BouvetIsland",
//   "Brazil",
//   "BritishIndianOceanTerritory",
//   "BruneiDarussalam",
//   "Bulgaria",
//   "BurkinaFaso",
//   "Burundi",
//   "Cambodia",
//   "Cameroon",
//   "Canada",
//   "CapeVerde",
//   "CaymanIslands",
//   "CentralAfricanRepublic",
//   "Chad",
//   "Chile",
//   "China",
//   "ChristmasIsland",
//   "Cocos(Keeling)Islands",
//   "Colombia",
//   "Comoros",
//   "Congo",
//   "Congo,TheDemocraticRepublicofthe",
//   "CookIslands",
//   "CostaRica",
//   'CoteD"Ivoire',
//   "Croatia",
//   "Cuba",
//   "Cyprus",
//   "CzechRepublic",
//   "Denmark",
//   "Djibouti",
//   "Dominica",
//   "DominicanRepublic",
//   "Ecuador",
//   "Egypt",
//   "ElSalvador",
//   "EquatorialGuinea",
//   "Eritrea",
//   "Estonia",
//   "Ethiopia",
//   "FalklandIslands(Malvinas)",
//   "FaroeIslands",
//   "Fiji",
//   "Finland",
//   "France",
//   "FrenchGuiana",
//   "FrenchPolynesia",
//   "FrenchSouthernTerritories",
//   "Gabon",
//   "Gambia",
//   "Georgia",
//   "Germany",
//   "Ghana",
//   "Gibraltar",
//   "Greece",
//   "Greenland",
//   "Grenada",
//   "Guadeloupe",
//   "Guam",
//   "Guatemala",
//   "Guernsey",
//   "Guinea",
//   "Guinea-Bissau",
//   "Guyana",
//   "Haiti",
//   "HeardIslandandMcdonaldIslands",
//   "HolySee(VaticanCityState)",
//   "Honduras",
//   "HongKong",
//   "Hungary",
//   "Iceland",
//   "India",
//   "Indonesia",
//   "Iran,IslamicRepublicOf",
//   "Iraq",
//   "Ireland",
//   "IsleofMan",
//   "Israel",
//   "Italy",
//   "Jamaica",
//   "Japan",
//   "Jersey",
//   "Jordan",
//   "Kazakhstan",
//   "Kenya",
//   "Kiribati",
//   'Korea,DemocraticPeople"SRepublicof',
//   "Korea,Republicof",
//   "Kuwait",
//   "Kyrgyzstan",
//   'LaoPeople"SDemocraticRepublic',
//   "Latvia",
//   "Lebanon",
//   "Lesotho",
//   "Liberia",
//   "LibyanArabJamahiriya",
//   "Liechtenstein",
//   "Lithuania",
//   "Luxembourg",
//   "Macao",
//   "Macedonia,TheFormerYugoslavRepublicof",
//   "Madagascar",
//   "Malawi",
//   "Malaysia",
//   "Maldives",
//   "Mali",
//   "Malta",
//   "MarshallIslands",
//   "Martinique",
//   "Mauritania",
//   "Mauritius",
//   "Mayotte",
//   "Mexico",
//   "Micronesia,FederatedStatesof",
//   "Moldova,Republicof",
//   "Monaco",
//   "Mongolia",
//   "Montenegro",
//   "Montserrat",
//   "Morocco",
//   "Mozambique",
//   "Myanmar",
//   "Namibia",
//   "Nauru",
//   "Nepal",
//   "Netherlands",
//   "NetherlandsAntilles",
//   "NewCaledonia",
//   "NewZealand",
//   "Nicaragua",
//   "Niger",
//   "Nigeria",
//   "Niue",
//   "NorfolkIsland",
//   "NorthernMarianaIslands",
//   "Norway",
//   "Oman",
//   "Pakistan",
//   "Palau",
//   "PalestinianTerritory,Occupied",
//   "Panama",
//   "PapuaNewGuinea",
//   "Paraguay",
//   "Peru",
//   "Philippines",
//   "Pitcairn",
//   "Poland",
//   "Portugal",
//   "PuertoRico",
//   "Qatar",
//   "Reunion",
//   "Romania",
//   "RussianFederation",
//   "RWANDA",
//   "SaintHelena",
//   "SaintKittsandNevis",
//   "SaintLucia",
//   "SaintPierreandMiquelon",
//   "SaintVincentandtheGrenadines",
//   "Samoa",
//   "SanMarino",
//   "SaoTomeandPrincipe",
//   "SaudiArabia",
//   "Senegal",
//   "Serbia",
//   "Seychelles",
//   "SierraLeone",
//   "Singapore",
//   "Slovakia",
//   "Slovenia",
//   "SolomonIslands",
//   "Somalia",
//   "SouthAfrica",
//   "SouthGeorgiaandtheSouthSandwichIslands",
//   "Spain",
//   "SriLanka",
//   "Sudan",
//   "Suriname",
//   "SvalbardandJanMayen",
//   "Swaziland",
//   "Sweden",
//   "Switzerland",
//   "SyrianArabRepublic",
//   "Taiwan,ProvinceofChina",
//   "Tajikistan",
//   "Tanzania,UnitedRepublicof",
//   "Thailand",
//   "Timor-Leste",
//   "Togo",
//   "Tokelau",
//   "Tonga",
//   "TrinidadandTobago",
//   "Tunisia",
//   "Turkey",
//   "Turkmenistan",
//   "TurksandCaicosIslands",
//   "Tuvalu",
//   "Uganda",
//   "Ukraine",
//   "UnitedArabEmirates",
//   "UnitedKingdom",
//   "UnitedStates",
//   "UnitedStatesMinorOutlyingIslands",
//   "Uruguay",
//   "Uzbekistan",
//   "Vanuatu",
//   "Venezuela",
//   "VietNam",
//   "VirginIslands,British",
//   "VirginIslands,U.S.",
//   "WallisandFutuna",
//   "WesternSahara",
//   "Yemen",
//   "Zambia",
//   "Zimbabwe",
// ];
const data = [
  "Afghanistan",
  "Afrique du Sud",
  "Albanie",
  "Algérie",
  "Allemagne",
  "Andorre",
  "Angola",
  "Anguilla",
  "Antarctique",
  "Antigua-et-Barbuda",
  "Antilles néerlandaises",
  "Arabie saoudite",
  "Argentine",
  "Arménie",
  "Aruba",
  "Australie",
  "Autriche",
  "Azerbaïdjan",
  "Bahamas",
  "Bahreïn",
  "Bangladesh",
  "Barbade",
  "Bélarus",
  "Belgique",
  "Belize",
  "Bénin",
  "Bermudes",
  "Bhoutan",
  "Bolivie",
  "Bosnie-Herzégovine",
  "Botswana",
  "Brésil",
  "Brunéi Darussalam",
  "Bulgarie",
  "BurkinaFaso",
  "Burundi",
  "Cambodge",
  "Cameroun",
  "Canada",
  "Cap-Vert",
  "Chili",
  "Chine",
  "Chypre",
  "Colombie",
  "Comores",
  "Congo",
  "Corée du nord",
  "Corée du sud",
  "Costa Rica",
  "Côte d’Ivoire",
  "Croatie",
  "Cuba",
  "Danemark",
  "Djibouti",
  "Dominique",
  "Egypte",
  "El Salvador",
  "Emirats arabes unis",
  "Equateur",
  "Erythrée",
  "Espagne",
  "Estonie",
  "Etats-Unis d’Amérique",
  "Ethiopie",
  "Fédération de Russie",
  "Fidji",
  "Finlande",
  "France",
  "Gabon",
  "Gambie",
  "Géorgie",
  "Ghana",
  "Gibraltar",
  "Grèce",
  "Groenland",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guinée",
  "Guinée équatoriale",
  "Guinée-Bissau",
  "Guyana",
  "Guyane française",
  "Haïti",
  "Honduras",
  "HongKong",
  "Hongrie",
  "Ile De Bouvet",
  "Ile Norfolk",
  "Iles Caïmanes",
  "Iles Cook<",
  "Iles d’Aland",
  "Iles Falkland",
  "Iles Féroé",
  "Iles Mariannes septentrionales",
  "Iles Marshall",
  "Iles Salomon",
  "Iles Svalbard et JanMayen",
  "Iles Turques et Caïques",
  "Iles Vierges américaines",
  "Iles Vierges britanniques",
  "Iles Wallis et Futuna",
  "Inde",
  "Indonésie",
  "Iran",
  "Iraq",
  "Irlande",
  "Islande",
  "Israel",
  "Italie",
  "Jamaïque",
  "Japon",
  "Jordanie",
  "Kazakhstan",
  "Kenya",
  "Kirghizistan",
  "Kiribati",
  "Koweït",
  "Laos",
  "Lesotho",
  "Lettonie",
  "Liban",
  "Libéria",
  "Libye",
  "Liechtenstein",
  "Lituanie",
  "Luxembourg",
  "Macao",
  "Madagascar",
  "Malaisie",
  "Malawi",
  "Maldives",
  "Mali",
  "Malte",
  "Maroc",
  "Martinique",
  "Maurice",
  "Mauritanie",
  "Mayotte",
  "Mexique",
  "Micronésie",
  "Moldovie",
  "Monaco",
  "Mongolie",
  "Montserrat",
  "Mozambique",
  "Myanmar",
  "Namibie",
  "Nauru",
  "Népal",
  "Nicaragua",
  "Niger",
  "Nigéria",
  "Nioué",
  "Norvège",
  "Nouvelle-Calédonie",
  "Nouvelle-Zélande",
  "Oman",
  "Ouganda",
  "Ouzbékistan",
  "Pakistan",
  "Palaos",
  "Panama",
  "Papouasie-Nouvelle-Guinée",
  "Paraguay",
  "Pays-Bas",
  "Pérou",
  "Philippines",
  "Pitcairn",
  "Pologne",
  "Polynésie française",
  "PortoRico",
  "Portugal",
  "Qatar",
  "République centrafricaine",
  "République démocratique du Congo",
  "République dominicaine",
  "République tchèque",
  "Réunion",
  "Roumanie",
  "Royaume-Uni",
  "Rwanda",
  "Saint-Kitts-et-Nevis",
  "Saint-Marin",
  "Saint-Pierre-et-Miquelon",
  "Saint-Siège",
  "Saint-Vincent-et-les Grenadines",
  "Sainte-Hélène",
  "Sainte-Lucie",
  "Samoa",
  "Samoas américaines",
  "SaoTomé-et-Principe",
  "Sénégal",
  "Serbie-et-Monténégro",
  "Seychelles",
  "Sierra Leone",
  "Singapour",
  "Slovaquie",
  "Slovénie",
  "Somalie",
  "Soudan",
  "SriLanka",
  "Suède",
  "Suisse",
  "Suriname",
  "Swaziland",
  "Syrie",
  "Tadjikistan",
  "Taiwan",
  "Tanzanie",
  "Tchad",
  "Territoire palestinien occupé",
  "Thaïlande",
  "Timor-Leste",
  "Togo",
  "Tokélaou",
  "Tonga",
  "Trinité-et-Tobago",
  "Tunisie",
  "Turkménistan",
  "Turquie",
  "Tuvalu",
  "Ukraine",
  "Uruguay",
  "Vanuatu",
  "Venezuela",
  "VietNam",
  "Yémen",
  "Zambie",
  "Zimbabwe",
];
export default data;
